
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
@Component({ components: {  } })
export default class SpinnerVue extends Vue {
  spin:number=0;
  key:number=0
  
  spin_callback(count:number) {
    this.spin=0
    if (count>0) this.spin=1;
    this.key++
  }

  async mounted() {
    Bus.set_spin_callback(this.spin_callback)
  }

}
 